export default __webpack_public_path__ + "static/doodle-1-21f6ecbbf341c55fe08ebc7678a1817b.svg";